export const integrationsCurrentsIntegrationDataId = "/integrations/currents_integration_data/:id";
